module.exports = __webpack_public_path__ + "img/BINDI 1 RED.95e2a41.svg";